import React from 'react';
import { isCordova } from 'utils/platform';
import LinkLogo from './LinkLogo';
import ListToggleLogo from './ListToggleLogo';

const CSS = require('./NavbarLogo.less');

interface NavbarLogoProps {
  transparent: boolean;
  isMobile: boolean;
  toggleList: () => void;
  closeList: () => void;
  openList: boolean;
  isHost: boolean;
}

function NavbarLogo({ transparent, isMobile, toggleList, closeList, openList, isHost }: NavbarLogoProps) {
  if (isCordova()) {
    return null;
  }

  return (
    <div className={CSS.LogoContainer}>
      {isMobile && !isHost ?
        <ListToggleLogo
          transparent={transparent}
          toggleList={toggleList}
          closeList={closeList}
          openList={openList}
        /> :
        <LinkLogo transparent={transparent} />
      }
    </div>
  );
}

export default NavbarLogo;
